import React, { useState } from 'react'
import SubscriptionApi from '../api/SubscriptionApi';


const ActivationLicense = () => {
  const [licenseKey, setLicenseKey] = useState('');
  const [error, setError] = useState('');
  const [success, setSuccess] = useState('');

  const handleActivation = async (e) => {
    e.preventDefault();
    setError('');
    setSuccess('');
  
    try {
      const response = await SubscriptionApi.activate(licenseKey);
  
      if (response.message) {
        setSuccess(response.message);
        localStorage.setItem('dac_activation_license', 'true'); 
      } else {
        setError(response.error);
      }
    } catch (err) {
      setError('An error occurred. Please try again.');
      console.error(err);
    }
  };
  

  return (
    <div className="w-full mx-auto  py-4">
      <h1 className="text-3xl text-start font-bold">Activate License</h1>
      <form className='max-w-[700px]' onSubmit={handleActivation}>
        <label className='block text-sm mt-4 mb-2'>License Key</label>
        <input  value={licenseKey}
          onChange={(e) => setLicenseKey(e.target.value)}  name='license_key' className='border px-4 py-3 my-2.5  placeholder:text-sm w-[82%] mt-[-3px]' placeholder='Paste your license key'/>
        <input type='submit' value="Activate" className='bg-black text-white px-4 py-2.5 border-2 text-sm ml-2'/>
        {error && <p className="text-red-500 mt-2">{error}</p>}
        {success && <p className="text-green-500 mt-2">{success}</p>}
      </form>
    </div>
  )
}

export default ActivationLicense;